import { css } from '@emotion/react'
import { FC } from 'react'

const Rows: FC = ({ children }) => {
  return <div css={rowsStyle}>{children}</div>
}

export default Rows

const rowsStyle = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`
